import type { Message } from './apiModels'

export function isAgentMailMessage(
  message: Pick<Message, 'direction' | 'user' | 'external_message_id'>,
): boolean {
  return message.direction === 'inbound' && (
    message.user === 'agent-mail'
    || message.external_message_id?.startsWith('agent-mail:') === true
    || message.external_message_id?.startsWith('agent-mail-summary:') === true
  )
}
